import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BuyPage = () => {
  const navigate = useNavigate();
  
  const buyOptions = [
    {
      title: "Buy on Arbitrum (Recommended)",
      description: "Trade directly on Arbitrum Network",
      path: "/buy/arbitrum",
      gradientFrom: "from-sky-400",
      gradientTo: "to-sky-500",
      hoverFrom: "hover:from-sky-500",
      hoverTo: "hover:to-sky-600",
      textColor: "text-sky-100"
    },
    {
      title: "Buy from any EVM Chain",
      description: "Supported chains: Ethereum L1, BASE, OP, and more",
      path: "/buy/evm",
      gradientFrom: "from-sky-500",
      gradientTo: "to-sky-600",
      hoverFrom: "hover:from-sky-600",
      hoverTo: "hover:to-sky-700",
      textColor: "text-sky-100"
    },
    {
      title: "Buy on Solana",
      description: "Trade on Solana Network",
      path: "/buy/solana",
      gradientFrom: "from-sky-600",
      gradientTo: "to-sky-700",
      hoverFrom: "hover:from-sky-700",
      hoverTo: "hover:to-sky-800",
      textColor: "text-sky-100"
    },
    {
      title: "Buy on CEX",
      description: "Trade on Centralized Exchanges",
      path: "/buy/cex",
      gradientFrom: "from-sky-700",
      gradientTo: "to-sky-800",
      hoverFrom: "hover:from-sky-800",
      hoverTo: "hover:to-sky-900",
      textColor: "text-sky-100"
    }
  ];

  return (
    <div className="bg-gradient-to-r from-sky-50 via-sky-50/80 to-white min-h-screen pt-16 md:pt-20">
      <div className="max-w-4xl mx-auto px-4 py-8 md:py-16">
        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-sky-500 mb-2 md:mb-4">Buy $BOOP</h1>
          <p className="text-gray-600 text-base md:text-lg">Choose your preferred network or exchange</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {buyOptions.map((option, index) => (
            <button
              key={index}
              onClick={() => navigate(option.path)}
              className={`
                group relative bg-gradient-to-r 
                ${option.gradientFrom} ${option.gradientTo} 
                ${option.hoverFrom} ${option.hoverTo} 
                p-4 md:p-6 rounded-xl transition-all duration-200 
                flex flex-col items-start 
                shadow-sm hover:shadow-md 
                backdrop-blur-sm border border-white/10
                hover:scale-[1.02] active:scale-[0.98]
                w-full
              `}
            >
              <div className="flex items-center justify-between w-full mb-2">
                <span className="text-lg md:text-xl font-semibold text-white">{option.title}</span>
                <ArrowUpRight className="w-5 h-5 text-white opacity-75 group-hover:opacity-100 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-all flex-shrink-0 ml-2" />
              </div>
              <p className={`${option.textColor} text-sm md:text-base opacity-90 break-normal text-left w-full`}>
                {option.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BuyPage;